/**
 * Regexes configuration.
 */
export const ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK = /^[a-zA-ZÀ-ÿ0-9\u00f1\u00d1\s.,_-]+$/
export const ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_FORMAT = /[^a-zA-ZÀ-ÿ0-9\u00f1\u00d1\s.,_-]/g
export const PROCESS_CODE_CHECK = /^[a-zA-Z0-9]{1,10}(-[a-zA-Z0-9]{1,10}){0,2}$/
